export default __webpack_public_path__ + "static/media/covered.2d0cd108.png";